import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon } from '@haldor/ui';
import './_page.scss';

var MenuPage = /*#__PURE__*/function (_Component) {
  _inherits(MenuPage, _Component);

  var _super = _createSuper(MenuPage);

  function MenuPage(props) {
    var _this;

    _classCallCheck(this, MenuPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getBadgeForItem", function (item) {
      if (_this.props.userUnread == null) {
        return null;
      }

      var user = _this.props.user;
      var activeSchool = localStorage.getItem('hal.school' + user.id);

      if (item.url == '/conversations') {
        return _this.props.userUnread.reduce(function (value, item) {
          if ((item.schoolId == 0 || item.schoolId == activeSchool) && item.type == 'CONVERSATION') {
            if (value == null) {
              value = 0;
            }

            return value += item.unread;
          }

          return value;
        }, null);
      }

      if (item.url == '/notifications') {
        return _this.props.userUnread.reduce(function (value, item) {
          if ((item.schoolId == 0 || item.schoolId == activeSchool) && item.type == 'NOT') {
            if (value == null) {
              value = 0;
            }

            return value += item.unread;
          }

          return value;
        }, null);
      }

      return null;
    });

    _this.blocked = ['NAV_HOME', 'NAV_SCHEDULE', 'NAV_PLANS'];
    return _this;
  }

  _createClass(MenuPage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var categories = [];

      if (this.props.items != null) {
        this.props.items.forEach(function (item) {
          if (item.parentId != null && item.parentId != '') {
            if (categories.indexOf(item.parentId) == -1) {
              categories.push(item.parentId);
            }
          }
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "menu-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "items-container"
      }, this.props.items != null ? this.props.items.map(function (item, index) {
        if (_this2.blocked.indexOf(item.text) > -1) {
          return null;
        }

        if (item.type == 'EXTERNAL') {
          return null;
        }

        if (item.parentId != null && item.parentId != '') {
          return null;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "menu-item-container",
          key: 'item-' + index
        }, /*#__PURE__*/React.createElement(Link, {
          to: item.url,
          onlyActiveOnIndex: true,
          activeClassName: "is-active",
          className: "menu-item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "menu-item-icon"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: item.iconId
        }), _this2.getBadgeForItem(item) != null ? /*#__PURE__*/React.createElement("span", {
          className: "badge"
        }, _this2.getBadgeForItem(item)) : null), /*#__PURE__*/React.createElement("span", null, _this2.props.translate(item.text.toLowerCase()))));
      }) : null, categories.map(function (category) {
        return /*#__PURE__*/React.createElement("div", {
          className: "menu-divider"
        }, /*#__PURE__*/React.createElement("div", {
          className: "divider-label"
        }, _this2.props.translate(category.toLowerCase())), /*#__PURE__*/React.createElement("div", {
          className: "items"
        }, _this2.props.items.map(function (item, index) {
          if (_this2.blocked.indexOf(item.text) > -1) {
            return null;
          }

          if (item.parentId != null && item.parentId == category) {
            return /*#__PURE__*/React.createElement("div", {
              className: "menu-item-container",
              key: 'item-' + index
            }, /*#__PURE__*/React.createElement(Link, {
              to: item.url,
              onlyActiveOnIndex: true,
              activeClassName: "is-active",
              className: "menu-item"
            }, /*#__PURE__*/React.createElement("div", {
              className: "menu-item-icon"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: item.iconId
            }), _this2.getBadgeForItem(item) != null ? /*#__PURE__*/React.createElement("span", {
              className: "badge"
            }, _this2.getBadgeForItem(item)) : null), /*#__PURE__*/React.createElement("span", null, _this2.props.translate(item.text.toLowerCase()))));
          }
        })));
      }), this.props.items != null ? this.props.items.map(function (item, index) {
        if (item.parentId != null && item.parentId != '') {
          return null;
        }

        if (item.type != 'EXTERNAL') {
          return null;
        }

        var label = item.text;

        if (label.indexOf('nav_') > -1) {
          label = _this2.props.translate(item.text.toLowerCase());
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "menu-item-container",
          key: 'item-' + index
        }, /*#__PURE__*/React.createElement("a", {
          href: item.url,
          target: "_blank",
          className: "menu-item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "menu-item-icon"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: item.iconId
        })), /*#__PURE__*/React.createElement("span", null, label)));
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        to: '/settings',
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Cog"
      })), /*#__PURE__*/React.createElement("span", null, this.props.translate('settings'))))));
    }
  }]);

  return MenuPage;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    items: state.Menu.items,
    userUnread: state.Notifications.userUnread
  };
}

export default connect(mapStateToProps)(MenuPage);